import axios from "axios";
import { apiUrl } from '../utils/constants';

axios.defaults.withCredentials = true
// const API_URL = "http://localhost:8081/api/user";
const API_URL = `${apiUrl}`;


const addCashInvestment = (data) => {
  console.log(data)
  return axios.post(API_URL + "/admin/cashInvestment", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};



const getCashTransactions = () => {
  return axios.get(API_URL + "/trans/cash")
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};



const getAdmins = (data) => {
  return axios.get(API_URL + "/admins", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};


const uploadImage = (data) => {
  console.log(data)
  return axios.post(API_URL + "/admin/upload", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};


const addQuestion = (data) => {
  console.log(data)
  return axios.post(API_URL + "/test/question", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};


const addFollowup = (data) => {
  console.log(data)
  return axios.post(API_URL + "/test/followup", data)
  .then((response) => {
    console.log(response.data)
    return response.data;
  });
};

const getQuestions = () => {
  return axios.get(API_URL + "/test/questions")
  .then((response) => {
    return response.data;
  });
};

const copyQuestion = (data) => {
  return axios.post(API_URL + "/test/copy", data)
  .then((response) => {
    return response.data;
  });
};

const deleteQuestion = (data) => {
  return axios.get(API_URL + `/test/delete/${data}`)
  .then((response) => {
    return response.data;
  });
};


export default {
    getAdmins,
    uploadImage,
    addCashInvestment,
    getCashTransactions,
    addQuestion,
    addFollowup,
    getQuestions,
    copyQuestion,
    deleteQuestion
};